import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import Checkbox from '../../../v2/forms/Checkbox';
import stopIntentTypes from '../../../../config/stop-intent-types';
import { mapIntentToSlug, mapSlugToIntent, } from '../../../../utils/formatters/stops';
import LocationAutosuggest from '../../../site/location-autosuggest';
import Badge from '../../../ui/Badge';
class TripStop extends Component {
    constructor(props) {
        super(props);
        this.handleDragEnter = (e) => {
            e.stopPropagation();
            this.setState({ hovering: true });
        };
        this.handleDragOver = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.setState({ hovering: true });
        };
        this.handleDragLeave = (e) => {
            e.stopPropagation();
            this.setState({ hovering: false });
        };
        this.handleEquipmentDrop = (e) => {
            e.preventDefault();
            e.stopPropagation();
            const { stop: { sequence }, } = this.props;
            const equipmentId = e.dataTransfer.getData('id');
            this.setState({ hovering: false });
            this.props.onEquipmentDrop(sequence, equipmentId);
        };
        this.state = {
            hovering: false,
        };
    }
    renderIntentDropdown() {
        const { stop, onIntentSelect, t } = this.props;
        return (React.createElement("div", { className: "px-4" },
            React.createElement("label", { className: "form-label mb-2 block" }, t('ACTION')),
            React.createElement("select", { className: "appearance-none form-select mb-4", onChange: (e) => onIntentSelect(stop.sequence, mapSlugToIntent(e.target.value)), value: mapIntentToSlug(stop) },
                React.createElement("option", { value: "" }, t('SELECT_INTENT')),
                stopIntentTypes.map((item) => (React.createElement("option", { key: item.slug, value: item.slug }, t(item.localizationSlug)))))));
    }
    renderLocationName() {
        const { stop, onLocationNameChange, t } = this.props;
        const location = getStagingStopLocation(stop);
        return (React.createElement("div", { className: "px-4" },
            React.createElement("label", { className: "form-label mb-2 block" }, t('LOCATION_NAME')),
            React.createElement("input", { type: "text", className: "form-field", placeholder: t('LOCATION_NAME'), value: location.name, onChange: (e) => onLocationNameChange(stop.sequence, e.target.value) })));
    }
    renderLocationAddress() {
        const { stop, onLocationSelect, onLocationAddressChange, t } = this.props;
        const location = getStagingStopLocation(stop);
        const { name, address } = location;
        return (React.createElement("div", { className: "px-4" },
            React.createElement("label", { className: "form-label mb-2 block" }, t('ADDRESS')),
            React.createElement(LocationAutosuggest, { id: `location-${stop.sequence}`, name: name, address: address, value: address, suggestions: [
                    {
                        name,
                        address,
                    },
                ], callbackSelectedItem: (item) => onLocationSelect(stop.sequence, item), onChange: (value) => onLocationAddressChange(stop.sequence, value) })));
    }
    render() {
        const { stop, onEquipmentRemove, onRemove, t } = this.props;
        const { hovering } = this.state;
        const className = getStopClassName({ hovering });
        return (React.createElement("div", { className: className, onDrop: this.handleEquipmentDrop, onDragOver: this.handleDragOver, onDragEnter: this.handleDragEnter, onDragLeave: this.handleDragLeave },
            React.createElement("div", { className: "p-4" },
                React.createElement("div", { className: "flex mb-4" },
                    React.createElement("div", { className: "px-4 bg-grey-darkest w-10 h-10 flex-shrink-0 flex-grow-0 rounded-full flex justify-center items-center text-white" }, stop.sequence),
                    React.createElement("div", { className: "flex flex-wrap" },
                        this.renderIntentDropdown(),
                        this.renderLocationName(),
                        this.renderLocationAddress(),
                        this.props.showOffSite && (React.createElement(Checkbox, { checked: stop.off_site, onChange: this.props.onOffsiteChange }, t('IS_OFFSITE'))),
                        React.createElement("div", null,
                            React.createElement("label", { className: "form-label mb-2 block" }, t('EQUIPMENT')),
                            stop.equipments.length > 0 &&
                                stop.equipments.map((equipment) => (React.createElement(Badge, { key: equipment._id, onClick: () => onEquipmentRemove(stop.sequence, equipment._id), text: equipment.equipment_id })))))),
                React.createElement("div", { className: "absolute top-0 right-0 mt-6 mr-6" },
                    React.createElement("button", { type: "button", className: "ml-2", onClick: () => onRemove(stop.sequence) },
                        React.createElement("i", { className: "text-grey fa fa-close" })))),
            this.state.hovering && (React.createElement("div", { className: "border-2 border-green-darker border-dashed absolute bg-green-lighter-transparent text-green-darker flex justify-center items-center w-full h-full top-0 left-0 pointer-events-none" },
                React.createElement("h3", { className: "mb-0 text-2xl" }, t('DROP_EQUIPMENT_TO_STOP'))))));
    }
}
TripStop.propTypes = {
    stop: PropTypes.shape({
        sequence: PropTypes.number.isRequired,
        action: PropTypes.oneOf(['pickup', 'deliver']),
        empty: PropTypes.bool.isRequired,
        location: PropTypes.shape({
            name: PropTypes.string,
            address: PropTypes.string,
        }),
    }),
    onEquipmentDrop: PropTypes.func.isRequired,
    onEquipmentRemove: PropTypes.func.isRequired,
    onLocationNameChange: PropTypes.func.isRequired,
    onIntentSelect: PropTypes.func.isRequired,
    onLocationSelect: PropTypes.func.isRequired,
    onLocationAddressChange: PropTypes.func.isRequired,
    onOffsiteChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    showOffSite: PropTypes.bool,
};
TripStop.defaultProps = {
    showOffSite: false,
};
function getStopClassName({ hovering }) {
    return classnames({
        '-mx-4': true,
        border: true,
        'border-grey-lighter': !hovering,
        'border-solid': !hovering,
        relative: true,
        'border-green-darker': hovering,
        'border-dotted': hovering,
    });
}
function getStagingStopLocation(stagingStop) {
    return (stagingStop.location || {
        address: '',
        name: '',
    });
}
export default withTranslation()(TripStop);
